import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOnePhoneValidator(requiredArrays: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !requiredArrays.length) return null;

    const isValid = requiredArrays.some((arrayName) => {
      const formArray = control.get(arrayName) as FormArray;
      return formArray && formArray.controls.some((group) => group.valid);
    });

    return isValid ? null : { atLeastOnePhone: true };
  };
}

export function newPasswordDiffersFromOldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const oldPassword = control.get('oldPassword')?.value;
    const newPassword = control.get('newPassword')?.value;

    if (oldPassword && newPassword && oldPassword === newPassword) {
      return { sameAsOld: true };
    }

    return null;
  };
}

export function confirmPasswordMatchesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const newPassword = control.get('newPassword')?.value;
    const confirmNewPassword = control.get('confirmNewPassword')?.value;

    if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
      return { passwordMismatch: true };
    }

    return null;
  };
}
